import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  subscribeWorkspace,
  toSortedArray,
} from "../../services/workspaceService";
import { BookOpen, ChevronRight } from "lucide-react";
import { useMobile } from "../../hooks/useMobile";
import HomeShell, { HomePageContent } from "../shell/HomeShell";
import { BACKGROUNDS } from "../../config/backgrounds";
import deskGlass from "../../styles/deskGlass";

const glass = deskGlass;

export default function ArticlesFeed() {
  const isMobile = useMobile();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = subscribeWorkspace((data) => {
      const all = [];
      for (const desk of data.desks || []) {
        for (const drawer of toSortedArray(desk.drawers)) {
          for (const notebook of toSortedArray(drawer.notebooks)) {
            for (const text of toSortedArray(notebook.texts)) {
              all.push({
                ...text,
                deskName: desk.name,
                deskSlug: desk.slug,
                drawerName: drawer.name,
                drawerSlug: drawer.slug,
                notebookName: notebook.name,
                notebookSlug: notebook.slug,
              });
            }
          }
        }
      }
      all.sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0));
      setArticles(all);
      setLoading(false);
    });
    return unsub;
  }, []);

  return (
    <HomeShell background={BACKGROUNDS.dashboard} fullHeight={false}>
    <HomePageContent>
    <div style={{ ...glass.deskContent, maxWidth: "1200px", paddingBottom: "120px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "32px", flexWrap: "wrap", gap: "12px" }}>
        <h1 style={glass.greeting}>Biblioteca</h1>
        <Link to="/drawers" style={{ ...glass.viewToggle, color: "#D4AF37", textDecoration: "none" }}>
          Ir al Escritorio <ChevronRight size={18} />
        </Link>
      </div>

      {loading ? (
        <div style={glass.center}>Cargando biblioteca...</div>
      ) : articles.length === 0 ? (
        <div style={glass.center}>No hay artículos aún.</div>
      ) : (
        <div style={{ ...styles.grid, ...(isMobile ? styles.gridMobile : {}) }}>
          {articles.map((art) => (
            <Link
              key={art.id}
              to={`/a/${art.deskSlug}/${art.drawerSlug}/${art.notebookSlug}/${art.id}?spa=true`}
              style={{
                ...glass.glassCard,
                textDecoration: "none",
                color: "inherit",
                padding: 0,
                overflow: "hidden",
              }}
            >
              {art.img && (
                <div style={styles.cardImageContainer}>
                  <img src={art.img} alt={art.title} style={styles.cardImage} />
                </div>
              )}
              <div style={styles.cardContent}>
                <div style={styles.cardHeader}>
                  <BookOpen size={16} color="#D4AF37" />
                  <span style={styles.cardMeta}>{art.notebookName}</span>
                </div>
                <h3 style={{ color: "#fff", margin: 0, fontSize: "1.1rem", fontWeight: "700" }}>{art.title}</h3>
                <div
                  style={styles.cardPreview}
                  dangerouslySetInnerHTML={{
                    __html: (art.content || "").replace(/<[^>]*>?/gm, "").slice(0, 100) + "...",
                  }}
                />
                <div style={styles.cardFooter}>
                  <span>{new Date(art.updatedAt).toLocaleDateString()}</span>
                  <span style={styles.readMore}>Leer más →</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
    </HomePageContent>
    </HomeShell>
  );
}

const styles = {
  gridMobile: {
    gridTemplateColumns: "1fr",
    gap: "16px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    gap: "24px",
  },
  cardImageContainer: {
    width: "100%",
    height: "160px",
    overflow: "hidden",
    borderBottom: "1px solid rgba(212,175,55,0.1)",
  },
  cardImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  cardContent: {
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    flex: 1,
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  cardMeta: {
    fontSize: "0.75rem",
    color: "#888",
    textTransform: "uppercase",
    letterSpacing: "1px",
  },
  cardPreview: {
    fontSize: "0.9rem",
    color: "#bbb",
    lineHeight: 1.5,
    maxHeight: "4.5em",
    overflow: "hidden",
    opacity: 0.8,
  },
  cardFooter: {
    marginTop: "auto",
    display: "flex",
    justifyContent: "space-between",
    fontSize: "0.75rem",
    color: "#666",
    paddingTop: "12px",
    borderTop: "1px solid rgba(255,255,255,0.05)",
  },
  readMore: {
    color: "#D4AF37",
    fontWeight: "bold",
  },
};
